// extracted by mini-css-extract-plugin
export var benchmarks = "pills-module--benchmarks--90294";
export var customerHub = "pills-module--customerHub--a94c0";
export var emailMarketing = "pills-module--emailMarketing--9de2d";
export var fadeOut = "pills-module--fadeOut--a7f8c";
export var floating1 = "pills-module--floating1--c05f9";
export var floating2 = "pills-module--floating2--1b693";
export var integrations = "pills-module--integrations--ecfb8";
export var klaviyoAi = "pills-module--klaviyoAi--7019a";
export var mobilePush = "pills-module--mobilePush--8aa76";
export var pill = "pills-module--pill--4c1a9";
export var pillContainer = "pills-module--pillContainer--1e756";
export var profiles = "pills-module--profiles--34c4d";
export var removePill = "pills-module--removePill--d6cf8";
export var removePills = "pills-module--removePills--a7ceb";
export var reporting = "pills-module--reporting--52296";
export var reviews = "pills-module--reviews--dcd85";
export var segments = "pills-module--segments--ed76f";
export var smsMarketing = "pills-module--smsMarketing--80df3";